import React from 'react';
import './Pillars.css';

const Pillars = () => (
  <section className="pillars-section">
    <div className="pillars-row">
      <span className="pillar-green">THINK</span>
      <span className="pillar-dark">CREATE</span>
      <span className="pillar-green">INNOVATE</span>
    </div>
    <div className="pillars-description">
      <p>Empowers businesses to achieve their goals through strategic technology implementation.
      We offer a comprehensive suite of solutions, including website updates and development, and custom application development. Our expertise spans creating tailored websites, ensuring ongoing maintenance and optimization, and building scalable web and mobile applications to streamline business processes that enhance customer engagement.</p>
    </div>
  </section>
);

export default Pillars; 